import * as React from "react";
import * as _ from "lodash";
import {ListScheduledTournamentRequest, ScheduledTournamentConfig} from "../../../../../generated/protocol";
import {ColumnType} from "../../../list/ColumnType";
import {EntityDataTable} from "../../../list/EntityDataTable";
import {
    ScheduledTournamentService,
    SCHEDULED_TOURNAMENT_SERVICE_NAME
} from "../../../../service/poker/tournament/ScheduledTournamentService";
import {Form, FormListener} from "../../../form/Form";
import {FormGroup} from "../../../form/FormGroup";
import {FormInput} from "../../../form/FormInput";
import {Validators} from "../../../form/Validators";
import {ListView, ListViewState, ListViewProps, createInitialState} from "../../ListView";
import {kernel} from "../../../../ioc/IOCHelper";
import {ActionType} from "../../../list/DataTable";
import {Link} from "react-router";
import {ScheduledTournamentsDataExport} from "./ScheduledTournamentsDataExport";


interface FilterForm {
    currencyCode?: string;
    archived?: boolean;
}

interface State extends ListViewState<ListScheduledTournamentRequest> {
    listRequest?: ListScheduledTournamentRequest;
    form?: FilterForm;
    validationMap?: any;
}

export class ScheduledTournamentListView extends ListView<State, ListScheduledTournamentRequest> implements FormListener<FilterForm> {


    scheduledTournamentService: ScheduledTournamentService;


    columns = [
        {property: "tournamentTemplateId", name: "ID", orderBy: "id"},
        {property: "configuration.name", name: "Name", orderBy: "configuration.name"},
        {property: "configuration.variant", name: "Variant"},
        {property: "configuration.currency", name: "Currency", orderBy: "configuration.currency", type: ColumnType.ENUM}
    ];
    actions = [
        {
            id: "copy",
            name: "Copy",
            className: "btn btn-primary",
            iconClassName: "fa fa-copy",
            type: ActionType.LINK,
            getLink: (item: ScheduledTournamentConfig) => "/tournament/new/" + item.tournamentTemplateId
        },
        {
            id: "edit",
            name: "Edit",
            className: "btn btn-warning",
            iconClassName: "fa fa-edit",
            type: ActionType.LINK,
            getLink: (item: ScheduledTournamentConfig) => "/tournament/" + item.tournamentTemplateId
        },
        {
            id: "delete",
            name: "Archive",
            className: "btn btn-danger",
            type: ActionType.CONFIRMATION,
            iconClassName: "fa fa-archive",
            filter: item => item.configuration.archived == false
        },
        {
            id: "delete",
            name: "Restore",
            className: "btn btn-danger",
            type: ActionType.CONFIRMATION,
            iconClassName: "fa fa-archive",
            filter: item => item.configuration.archived == true
        }
    ];

    constructor(props: ListViewProps) {
        super(props, "/tournaments");
        this.state = createInitialState({orderBy: "id", archived: false, currencyCode: null}, this.state);
        this.scheduledTournamentService = kernel.get<ScheduledTournamentService>(SCHEDULED_TOURNAMENT_SERVICE_NAME);
    }

    formDidUpdate(formModel: FilterForm, validationMap: any) {
        formModel.currencyCode = formModel.currencyCode != "" ? formModel.currencyCode : null;
        this.setState({form: formModel, validationMap: validationMap});
    }

    onSubmit() {
        console.log("On submit = ", this.state.form);
        var listRequest = _.clone(this.state.listRequest);
        listRequest.archived = this.state.form.archived;
        var currencyCode = this.state.form.currencyCode;
        listRequest.currencyCode = currencyCode != "" ? currencyCode : null;
        this.updateListState(listRequest);
    }

    onSubmitError() {
        console.log("SUBMIT ERROR, ", this.state.validationMap, this.state.form);
    }

    onAction(item: ScheduledTournamentConfig, action: string) {
        if (action == "copy") {
            this.navigate("/tournament/new/" + item.tournamentTemplateId);
        } else if (action == "edit") {
            this.navigate("/tournament/" + item.tournamentTemplateId);
        } else if (action == "delete") {
            if (item.configuration.archived) {
                return this.scheduledTournamentService.restore(item.tournamentTemplateId)
            } else {
                return this.scheduledTournamentService.archive(item.tournamentTemplateId);
            }
        }
    }

    renderContent() {

        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Scheduled Tournaments</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <Link style={{marginTop: "5px"}} className="btn btn-primary" to="/tournament/new">
                                <i className="fa fa-file"></i> Create Scheduled Tournament
                            </Link>
                        </div>
                    </div>

                    <ScheduledTournamentsDataExport />

                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Filter Tournaments</h5>
                        </div>
                        <div className="ibox-content">
                            <Form className="form-horizontal" formListener={this} modelObject={this.state.form}
                                  validationMap={this.state.validationMap}>
                                <FormGroup className="form-group" model="currencyCode">
                                    <label className="col-lg-2 control-label">Currency:</label>
                                    <div className="col-lg-10">
                                        <FormInput className="form-control" model="currencyCode"
                                                   validators={[Validators.strLengths([0, 3])]} type="text"/>
                                        <span className="help-block m-b-none">Three character currency code (USD, XMB, XCC etc)</span>
                                    </div>
                                </FormGroup>
                                <FormGroup className="form-group">
                                    <label className="col-lg-2 control-label">Archived:</label>
                                    <div className="col-lg-10">
                                        <FormInput model="archived" type="checkbox"/>
                                        <span className="help-block m-b-none">Include archived templates</span>
                                    </div>
                                </FormGroup>
                                <div className="form-group">
                                    <div className="col-lg-offset-2 col-lg-10">
                                        <input className="btn btn-primary" value="Apply" type="submit"/>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>

                    <EntityDataTable service={this.scheduledTournamentService} columns={this.columns}
                                     actions={this.actions} listRequest={this.state.listRequest}
                                     onPagerChange={this.pagerChanged.bind(this)} onAction={this.onAction.bind(this)}/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/view/poker/tournament/ScheduledTournamentListView.tsx